module.exports = __webpack_public_path__ + "static/media/manzo_02_full.989686ef.jpg";